import React from 'react';
import { StyledBox } from '../config/Style';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

function Result({ answer }) {
    const cleanAnswer = answer
        ? answer
            .replace(/\\n/g, '\n')
            .replace(/\\t/g, '    ')
            .replace(/\\/g, '')
        : "chill chill...";

    return (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
            <StyledBox>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {cleanAnswer}
                </ReactMarkdown>
            </StyledBox>
        </div>
    );
}

export default Result;
